/** Small Win94 toast above the tray; optional action button or dedupe key. */
const keyed = new Map<string, HTMLElement>();

export function showToast(
  parent: HTMLElement,
  text: string,
  actionLabel?: string,
  onAction?: () => void,
  key?: string,
): void {
  // a keyed toast replaces any prior toast with the same key (no stacking)
  if (key) {
    keyed.get(key)?.remove();
  }

  const toast = document.createElement('div');
  toast.className = 'w94-raised';
  toast.style.cssText = [
    'position:fixed',
    'left:50%',
    'transform:translateX(-50%)',
    'bottom:calc(84px + env(safe-area-inset-bottom))',
    'padding:8px 12px',
    'display:flex',
    'align-items:center',
    'gap:10px',
    'font:bold 11px/1.35 monospace',
    'color:var(--w94-text)',
    'z-index:30',
    'pointer-events:auto',
    'max-width:86vw',
    'text-align:center',
    'cursor:pointer',
  ].join(';');

  const label = document.createElement('span');
  label.textContent = text;
  toast.appendChild(label);

  const dismiss = (): void => {
    toast.remove();
    if (key && keyed.get(key) === toast) keyed.delete(key);
  };

  if (actionLabel && onAction) {
    const btn = document.createElement('button');
    btn.className = 'w94-btn';
    btn.textContent = actionLabel;
    btn.style.cssText = 'height:30px;padding:0 10px;flex:none;';
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      dismiss();
      onAction();
    });
    toast.appendChild(btn);
    // action toasts linger longer, but a tap on the body still dismisses
    window.setTimeout(dismiss, 14000);
  } else {
    window.setTimeout(dismiss, 8000);
  }

  toast.addEventListener('click', dismiss);
  if (key) keyed.set(key, toast);
  parent.appendChild(toast);
}
